// MUI
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// screen
import { useTabsData } from 'modules/suppliers/detail/context/useTabsData';
import BackToSuppliersPageButton from 'modules/suppliers/detail/components/BackToSuppliersPageButton';

interface CommodityClassification {
  id: string;
  name: string;
  selected: boolean;
  commodityGroups: { id: string; name: string; selected: boolean }[];
}

/**
 * Chỉ hiển thị những phần tử được chọn, nếu không được chọn thì không hiển thị.
 */
const GoodsTypePanel = () => {
  const { generalDetails } = useTabsData();
  if (!generalDetails) return null;

  const goodsTypes = generalDetails.commodityClassifications || [];

  return (
    <Box>
      {(goodsTypes as unknown as CommodityClassification[]).map((category, index) => {
        const isAllSelected = !!category.selected;

        const partlySelected =
          category.commodityGroups.some((item) => item.selected) && !isAllSelected;

        const shouldShow = isAllSelected || partlySelected;

        const displayCheckbox = () => {
          return shouldShow ? (
            <Typography sx={{ fontWeight: 600 }}>
              {isAllSelected ? <Checkbox disabled checked /> : <Checkbox disabled indeterminate />}{' '}
              {category.name || ''}
            </Typography>
          ) : null;
        };

        const displayName = () => {
          return category.commodityGroups.map((type, typeIndex) =>
            shouldShow && type.selected ? (
              <Box key={typeIndex} sx={{ ml: 3, mb: 1 }}>
                <Typography variant="body1">
                  <Checkbox disabled checked={type.selected} />
                  {type.name}
                </Typography>
              </Box>
            ) : null
          );
        };

        return (
          <Box key={index} mb={4}>
            {displayCheckbox()}
            {displayName()}
          </Box>
        );
      })}
      <BackToSuppliersPageButton />
    </Box>
  );
};

export default GoodsTypePanel;
